__turbopack_context__.v({
  "iconArrow": "styles-module-scss-module__u4v9ya__iconArrow",
  "identifyIcon": "styles-module-scss-module__u4v9ya__identifyIcon",
  "verification": "styles-module-scss-module__u4v9ya__verification",
  "verifyButton": "styles-module-scss-module__u4v9ya__verifyButton",
  "verifyRowContainer": "styles-module-scss-module__u4v9ya__verifyRowContainer",
});
